import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'
import Home from './views/Contacts.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/*',
      name: 'home',
      component: Home
    }// ,
    // {
    //   path: '/mission',
    //   name: 'mission',
    //   redirect: {
    //     name: 'heritage'
    //   }
    // },
    // {
    //   path: '/mission/heritage',
    //   name: 'heritage',
    //   component: () => import(/* webpackChunkName: "heritage" */ './views/Mission/Heritage.vue')
    // },
    // {
    //   path: '/mission/creation',
    //   name: 'creation',
    //   component: () => import(/* webpackChunkName: "creation" */ './views/Mission/Creation.vue')
    // },
    // {
    //   path: '/mission/partnership',
    //   name: 'partnership',
    //   component: () => import(/* webpackChunkName: "partnership" */ './views/Mission/Partnership.vue')
    // },
    // {
    //   path: '/services',
    //   name: 'services',
    //   redirect: {
    //     name: 'companies'
    //   }
    // },
    // {
    //   path: '/services/companies',
    //   name: 'companies',
    //   component: () => import(/* webpackChunkName: "companies" */ './views/Services/Companies.vue')
    // },
    // {
    //   path: '/services/dialog',
    //   name: 'dialog',
    //   component: () => import(/* webpackChunkName: "dialog" */ './views/Services/Dialog.vue')
    // },
    // {
    //   path: '/services/ecosystem',
    //   name: 'ecosystem',
    //   component: () => import(/* webpackChunkName: "ecosystem" */ './views/Services/Ecosystem.vue')
    // },
    // {
    //   path: '/services/anticrisis',
    //   name: 'anticrisis',
    //   component: () => import(/* webpackChunkName: "anticrisis" */ './views/Services/Anticrisis.vue')
    // },
    // {
    //   path: '/services/design',
    //   name: 'design',
    //   component: () => import(/* webpackChunkName: "design" */ './views/Services/Design.vue')
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   redirect: {
    //     name: 'individualism'
    //   }
    // },
    // {
    //   path: '/about/individualism',
    //   name: 'individualism',
    //   component: () => import(/* webpackChunkName: "individualism" */ './views/About/Individualism.vue')
    // },
    // {
    //   path: '/about/relations',
    //   name: 'relations',
    //   component: () => import(/* webpackChunkName: "relations" */ './views/About/Relations.vue')
    // },
    // {
    //   path: '/about/motion',
    //   name: 'motion',
    //   component: () => import(/* webpackChunkName: "motion" */ './views/About/Motion.vue')
    // },
    // {
    //   path: '/contacts',
    //   name: 'contacts',
    //   component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
    // }
  ]
})
